import { Currency } from '@core/types/api/Currency/Currency';
import Enums from '@core/types/api/Enums';

type CalculateWithDeliveryTotalPriceParams = {
  unitPrice: Currency;
  haulRate: Currency;
  taxRate: number;
  haulTaxable: boolean;
};

/**
 * Calculates the total price for an aggregate product based on
 * the unit price, haul rate and tax rate.
 */
export const CalculateWithDeliveryTotalPrice = ({
  unitPrice,
  haulRate,
  taxRate,
  haulTaxable,
}: CalculateWithDeliveryTotalPriceParams): Currency | null => {
  const priceAfterTax = unitPrice.multiply(1 + taxRate) ?? Currency.zero();
  const haulTaxRate = haulTaxable ? taxRate : 0;
  const rateAfterTax = haulRate.multiply(1 + haulTaxRate) ?? Currency.zero();

  return priceAfterTax.add(rateAfterTax);
};

export const WithDeliveryProductCategory = (category: Enums.ProductCategory): boolean =>
  [Enums.ProductCategory.Asphalt, Enums.ProductCategory.Aggregate].includes(category);
